import CommonEdit from "@/components/common/Edit"
import VehicleForm from "../forms/VehicleForm"
import { FC, useEffect, useState } from "react"
import { vehicleForm } from "@/utils/objects"
import { singleProp } from "@/interface/dataInterface"
import axios from "axios"
import { BASE_URL } from "@/config"
import axiosInstance from "@/utils/axiosInstance"



const VehicleEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState(vehicleForm)

    useEffect(() => {
        const unsub = async () => {
            const response = await axiosInstance.get(`/auto-service/vehicles/${prop}`)
            setFormProp(response.data)
        }

        unsub()
    }, [prop])

    return (
        <CommonEdit title="Edit" id={prop} resource="auto-service/vehicles" data={formProp}>
            <VehicleForm mode="edit" formProp={formProp} setFormProp={setFormProp} />
        </CommonEdit>
    )
}

export default VehicleEdit